import React, { useState } from 'react';
import './Navbar.css';
import logo from '../../assets/frontend_assets/logo.png';
import cart_icon from '../../assets/frontend_assets/cart_icon.png';
import search_icon from '../../assets/frontend_assets/search_icon.png';
import profile_icon from '../../assets/frontend_assets/profile_icon.png';
import cross_icon from '../../assets/frontend_assets/cross_icon.png';
import menu_icon from '../../assets/frontend_assets/menu_icon.png';
import { useNav } from '../../Context/NavContext'; // ✅ Import NavContext
import { useSearchBar } from '../../Context/SearchBarContext';
import { useUser } from '../../Context/UserContext';
import LogoutButton from '../LogoutButton/LogoutButton';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const { activeItem, setActiveItem } = useNav(); // ✅ Use global context
  const { isSearchOpen, toggleSearch } = useSearchBar();
  const { isLoggedIn } = useUser();
  console.log(isLoggedIn)

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleNavClick = (item) => {
    setActiveItem(item);  // ✅ Update global state
    setMenuOpen(false);   // Close mobile menu on click
  };

  return (
    <div className='navbar_container'>
      <div className="nav_logo">
        <img src={logo} alt="logo" />
      </div>
      <div className={`nav_list ${menuOpen ? 'active' : ''}`}>
        <ul>
          <li
            className={activeItem === 'HOME' ? 'active' : ''}
            onClick={() => handleNavClick('HOME')}
          >
            HOME
          </li>
          <li
            className={activeItem === 'COLLECTION' ? 'active' : ''}
            onClick={() => handleNavClick('COLLECTION')}
          >
            COLLECTION
          </li>
          <li
            className={activeItem === 'ABOUT' ? 'active' : ''}
            onClick={() => handleNavClick('ABOUT')}
          >
            ABOUT
          </li>
          <li
            className={activeItem === 'CONTACT' ? 'active' : ''}
            onClick={() => handleNavClick('CONTACT')}
          >
            CONTACT
          </li>
        </ul>
      </div>
      <div className="nav_icons">
        <div className="nav_icon_con">
          {activeItem === 'COLLECTION' && (
            <div className="search_icon" onClick={toggleSearch}>
              <img src={search_icon} alt="search" />
            </div>
          )}
          <div className="log_icon">
            {isLoggedIn ? (
              <LogoutButton />
            ) : (
              <img src={profile_icon} alt="profile" onClick={() => handleNavClick('ACCESS')} />
            )}
          </div>
          <div className="cart_icon" onClick={() => handleNavClick('CART')}>
            <img src={cart_icon} alt="cart" />
          </div>
        </div>
      </div>
      <div className="mobile_menu" onClick={toggleMenu}>
        <img src={menuOpen ? cross_icon : menu_icon} alt="menu toggle" />
      </div>
    </div>
  );
}

export default Navbar;
